import { render, staticRenderFns } from "./fpdpenalty.vue?vue&type=template&id=3fc57de5&scoped=true&"
import script from "./fpdpenalty.vue?vue&type=script&lang=js&"
export * from "./fpdpenalty.vue?vue&type=script&lang=js&"
import style0 from "./fpdpenalty.vue?vue&type=style&index=0&id=3fc57de5&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc57de5",
  null
  
)

export default component.exports